'use strict'

export default {
  getTextQuestionName: function(question) {
    if (question.text && question.text.length > 0) {
      return question.text
    }

    return question.defaultText
  },
  showBadgeForTextQuestion: function(tab, question) {
    if (tab.isDefaultLanguage) {
      return false
    }

    if (!(question && question.text && question.text.length > 0)) {
      return true
    }

    if (
      !(
        question.alternatives &&
        question.alternatives.constructor === Array &&
        question.alternatives.length > 0
      )
    ) {
      return true
    }

    var doShow = false

    for (var i = 0; i < question.alternatives.length; i++) {
      var alternative = question.alternatives[i]

      if (!(alternative.text && alternative.text.length > 0)) {
        doShow = true
        break
      }
    }

    return doShow
  },
  addAlternative(alternatives) {
    alternatives.push({
      questionAlternativeId: '',
      questionAlternativeLanguageId: '',
      points: 0,
      alternativePoints: 0,
      text: '',
      imageUrl: '',
      defaultText: ''
    })
  },
  addQuestion(questions) {
    questions.push(this.createQuestion())
  },
  createQuestion() {
    return {
      id: '',
      questionLanguageId: '',
      text: '',
      defaultText: '',
      value1: '',
      value2: '',
      value3: '',
      value4: '',
      hasNumericalImages: false,
      difficultyLevel: 1,
      alternatives: [],
      images: []
    }
  },
  deleteObjectFromCollection(collection, index) {
    if (index !== -1) {
      collection.splice(index, 1)
    }
  }
}
